import dayjs from 'dayjs';

import { BadgeColor } from 'types';
import type { Reader, ReaderTone } from 'store/api/clover/reader-status';

// The dot colours are the app's own badge dot tokens (theme.config.badge.*.dot,
// light and dark themes): green / amber / red / grey, as plan §1.
export const READER_TONE_COLOR: Record<ReaderTone, BadgeColor> = {
  bad: BadgeColor.Red,
  ok: BadgeColor.Green,
  muted: BadgeColor.Grey,
  warn: BadgeColor.Yellow,
};

// "Last seen": "just now", "2 min ago", "today 9:14 AM", "yesterday 6:02 PM",
// then "Oct 18, 6:02 PM". Empty when the reader has never answered.
export const lastSeenText = (
  value?: string | null,
  now: dayjs.ConfigType = new Date()
): string => {
  const at = value ? dayjs(value) : null;
  if (!at || !at.isValid()) {
    return '';
  }
  const current = dayjs(now);
  const minutes = Math.max(0, current.diff(at, 'minute'));
  if (minutes < 1) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  if (at.isSame(current, 'day')) {
    return `today ${at.format('h:mm A')}`;
  }
  if (at.isSame(current.subtract(1, 'day'), 'day')) {
    return `yesterday ${at.format('h:mm A')}`;
  }
  return at.format(
    at.isSame(current, 'year') ? 'MMM D, h:mm A' : 'MMM D, YYYY'
  );
};

export const findReader = (
  readers: Reader[] | undefined,
  deviceId?: number | string | null
) =>
  deviceId === undefined || deviceId === null || deviceId === ''
    ? undefined
    : readers?.find((reader) => reader.deviceId === Number(deviceId));
